import { UploadIcon } from 'lucide-react';
import { cn } from '@rocco/utils/cn';

/**
 * Overlay displayed when files are dragged over the chat box,
 * indicating the user can drop files to upload them.
 */
export function ChatBoxDropOverlay({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                'absolute inset-0 z-10 flex flex-col items-center justify-center gap-[8px] rounded-[inherit] bg-black/70',
                className,
            )}
        >
            <UploadIcon className="size-[24px] text-white/80" />
            <span className="text-center text-[16px] font-semibold leading-tight text-white">
                Drop files here
            </span>
        </div>
    );
}
